export function decodeJwt(jwt: string): Record<string, unknown> {
    return JSON.parse(atob(jwt.split(".")[1].replace(/_/g, "/").replace(/-/g, "+")).toString());
}
